module.exports = __webpack_public_path__ + "public/img/Dasar Keselamatan Dan Kesehatan Kerja Di Tempat Kerja.25d4aa8c.png";